import { render, staticRenderFns } from "./Invesments.vue?vue&type=template&id=a57ac6b2&"
import script from "./Invesments.vue?vue&type=script&lang=js&"
export * from "./Invesments.vue?vue&type=script&lang=js&"
import style0 from "./Invesments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports